import React from 'react';

import { useSelectedTheme, useTranslate } from '../../../Hooks';
import { CustomBadge } from '../CustomBadge';
import { Box } from '@material-ui/core';

import useStyles from './styles';
function PropertyPublishBadges({ PropertyWebPublishedStatus }) {
  const { translate } = useTranslate('NewPropertiesView');
  const isPublished = PropertyWebPublishedStatus === true;

  const {
    theme: { palette },
  } = useSelectedTheme();

  const styles = useStyles();

  return (
    <>
      {isPublished && (
        <>
          <Box className={styles.badgeSection}>
            <CustomBadge
              key={PropertyWebPublishedStatus}
              SizeVariant='large'
              label={translate('published')}
              BackgroundColor={'rgba(248, 249, 252, 0.50)'}
              BorderColor={`rgba(255, 255, 255, 0.4)`}
              Color={palette.button.secondaryGray_fg_hover}
              Style={{
                backdropFilter: 'blur(4px)',
              }}
            />
          </Box>
        </>
      )}
    </>
  );
}

export default PropertyPublishBadges;
